export default __webpack_public_path__ + "./images/so.ac02d0df.png";